var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-row customize-editor-minimize" },
    [
      _c("div", { staticClass: "editor-row-title" }, [
        _vm._v(_vm._s(_vm.$t("auto.stringFormatterTrimTrimMode"))),
      ]),
      _vm._v(" "),
      _c(
        "a-radio-group",
        {
          model: {
            value: _vm.clone.trim.mode,
            callback: function ($$v) {
              _vm.$set(_vm.clone.trim, "mode", $$v)
            },
            expression: "clone.trim.mode",
          },
        },
        [
          _c("a-radio", { attrs: { value: "both" } }, [
            _vm._v(_vm._s(_vm.$t("auto.stringFormatterTrimBothSides"))),
          ]),
          _vm._v(" "),
          _c("a-radio", { attrs: { value: "start" } }, [
            _vm._v(_vm._s(_vm.$t("auto.stringFormatterTrimStartOnly"))),
          ]),
          _vm._v(" "),
          _c("a-radio", { attrs: { value: "end" } }, [
            _vm._v(_vm._s(_vm.$t("auto.stringFormatterTrimEndOnly"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("small", { staticClass: "description" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t(
                "auto.stringFormatterTrimSelectWhichPartsOfTheTextShouldHaveWhitespaceRemoved"
              )
            ) +
            "\n    "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }